import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';
import {
  getTicketSettingListSearchForm,
  setTicketSettingListSearchForm,
  removeTicketSettingListSearchForm,
} from '@/utils/localstorage';
import { TicketSetting } from '@/api/types';

type TicketSettingListSearchForm = {
  planId: string | null;
  unitId: string | null;
};

export interface ITicketSettingState {
  ticketSettingListSearchForm: TicketSettingListSearchForm;
  ticketSettingListSearchResult: TicketSetting[];
}

@Module({
  dynamic: true,
  name: 'ticketsetting',
  store,
})
class TicketSettingStore extends VuexModule implements ITicketSettingState {
  private static readonly defaultTicketSettingListSearchForm = {
    planId: null,
    unitId: null,
  };

  public ticketSettingListSearchForm = getTicketSettingListSearchForm()
    ? (JSON.parse(
        getTicketSettingListSearchForm()!
      ) as TicketSettingListSearchForm)
    : TicketSettingStore.defaultTicketSettingListSearchForm;
  public ticketSettingListSearchResult: TicketSetting[] = [];

  @Mutation
  private SET_TICKET_SETTING_LIST_SEARCH_FORM(
    form: TicketSettingListSearchForm
  ) {
    this.ticketSettingListSearchForm = form;
  }

  @Mutation
  private SET_TICKET_SETTING_LIST_SEARCH_RESULT(result: TicketSetting[]) {
    this.ticketSettingListSearchResult = result;
  }

  @Action
  public SaveTicketSettingListSearchForm(form: TicketSettingListSearchForm) {
    setTicketSettingListSearchForm(JSON.stringify(form));
    this.SET_TICKET_SETTING_LIST_SEARCH_FORM(form);
  }

  @Action
  public ClearTicketSettingListSearchForm() {
    removeTicketSettingListSearchForm();
    this.SET_TICKET_SETTING_LIST_SEARCH_FORM(
      TicketSettingStore.defaultTicketSettingListSearchForm
    );
  }

  @Action
  public SaveTicketSettingListSearchResult(result: TicketSetting[]) {
    this.SET_TICKET_SETTING_LIST_SEARCH_RESULT(result);
  }

  @Action
  public ClearTicketSettingListSearchResult() {
    this.SET_TICKET_SETTING_LIST_SEARCH_RESULT([]);
  }

  @Action ClearTicketSettingStore() {
    this.ClearTicketSettingListSearchForm();
    this.ClearTicketSettingListSearchResult();
  }
}

export const TicketSettingModule = getModule(TicketSettingStore);
